import React from 'react';
import { Icon } from 'antd';
import {
  ChargeableIcon,
  ClipIcon,
  DangerSignIcon,
  GarantyIcon,
  PhoneIcon,
  QuestionSignIcon,
  RetryTwoArrowsIcon,
  ToolIcon,
} from '../../../resource/icons';
import { ReactComponent as NotWarrantyIcon } from '../../../resource/NotWarrantyIcon.svg';
import { dspxDiffDays } from '../../../helpers/dspx-utils';

export const markNames = {
  hasRecord: 'hasRecord',
  hasAttachment: 'hasAttachment',
  isInternal: 'isInternal',
  isImmediate: 'isImmediate',
  isChargeable: 'isChargeable',
  possWarranty: 'possWaranty',
  warranty: 'warranty',
  noWarranty: 'noWarranty',
  isRetry: 'isRetry',
  expired: 'expired',
};

export const markMapKeys = {
  [markNames.hasRecord]: 1,
  [markNames.hasAttachment]: 2,
  [markNames.isInternal]: 3,
  [markNames.isImmediate]: 4,
  [markNames.isChargeable]: 5,
  [markNames.noWarranty]: 6,
  [markNames.possWarranty]: 7,
  [markNames.warranty]: 8,
  [markNames.isRetry]: 9,
  [markNames.expired]: 10,
};

export const initialMarksMap = new Map([
  [
    markNames.hasRecord,
    {
      id: markMapKeys[markNames.hasRecord],
      name: 'С записью разговора',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.hasAttachment,
    {
      id: markMapKeys[markNames.hasAttachment],
      name: 'С вложением',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.isInternal,
    {
      id: markMapKeys[markNames.isInternal],
      name: 'Внутренняя',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.isImmediate,
    {
      id: markMapKeys[markNames.isImmediate],
      name: 'Аварийные',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.isChargeable,
    {
      id: markMapKeys[markNames.isChargeable],
      name: 'Платные',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.noWarranty,
    {
      id: markMapKeys[markNames.noWarranty],
      name: 'Не гарантия',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.possWarranty,
    {
      id: markMapKeys[markNames.possWarranty],
      name: 'Возможно гарантия',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.warranty,
    {
      id: markMapKeys[markNames.warranty],
      name: 'Гарантия',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.isRetry,
    {
      id: markMapKeys[markNames.isRetry],
      name: 'Открытые повторно',
      value: 0,
      percent: 0,
    },
  ],
  [
    markNames.expired,
    {
      id: markMapKeys[markNames.expired],
      name: 'Просроченные',
      value: 0,
      percent: 0,
    },
  ],
]);

export const marksMap = new Map([
  [
    markMapKeys[markNames.hasRecord],
    {
      id: markMapKeys[markNames.hasRecord],
      has: (request) => request.hasRecord,
      field: markNames.hasRecord,
      description: 'С записью разговора',
      icon: <PhoneIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.hasAttachment],
    {
      id: markMapKeys[markNames.hasAttachment],
      has: (request) => request.hasAttachment,
      field: markNames.hasAttachment,
      description: 'С вложением',
      icon: <ClipIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.isInternal],
    {
      id: markMapKeys[markNames.isInternal],
      has: (request) => request.isInternal,
      field: markNames.isInternal,
      description: 'Внутренняя',
      icon: <ToolIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.isImmediate],
    {
      id: markMapKeys[markNames.isImmediate],
      has: (request) => request.isImmediate,
      field: markNames.isImmediate,
      description: 'Аварийные',
      icon: <DangerSignIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.isChargeable],
    {
      id: markMapKeys[markNames.isChargeable],
      has: (request) => request.isChargeable,
      field: markNames.isChargeable,
      description: 'Платные',
      icon: <ChargeableIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.noWarranty],
    {
      id: markMapKeys[markNames.noWarranty],
      has: (request) => !request.garanty || request.garantyId === 0,
      field: markNames.noWarranty,
      description: 'Не гарантия',
      icon: (
        <Icon
          component={NotWarrantyIcon}
          style={{ marginRight: 5, color: 'transparent', fontSize: '24px' }}
        />
      ),
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.possWarranty],
    {
      id: markMapKeys[markNames.possWarranty],
      has: (request) => request.garantyId === 2,
      field: markNames.possWarranty,
      description: 'Возможно гарантия',
      icon: <QuestionSignIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.warranty],
    {
      id: markMapKeys[markNames.warranty],
      has: (request) => request.garantyId === 1,
      field: markNames.warranty,
      description: 'Гарантия',
      icon: <GarantyIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.isRetry],
    {
      id: markMapKeys[markNames.isRetry],
      has: (request) => request.isRetry,
      field: markNames.isRetry,
      description: 'Открытые повторно',
      icon: <RetryTwoArrowsIcon style={{ marginRight: 5 }} />,
      amount: 0,
    },
  ],
  [
    markMapKeys[markNames.expired],
    {
      id: markMapKeys[markNames.expired],
      has: (request) => {
        const diff = request.doneDate
          ? dspxDiffDays(request.doneDate, request.executeTime)
          : dspxDiffDays(0, request.executeTime);

        return diff > 0 ? true : false;
      },
      field: markNames.expired,
      description: 'Просроченные',
      icon: (
        <Icon
          type="fire"
          style={{ marginRight: 5, fontSize: 24, color: '#ff0003' }}
        />
      ),
      amount: 0,
    },
  ],
]);

export const markPlaceholders = {
  isBadWork: {
    name: 'Для обсуждения',
    value: 0,
  },
  notGaranty: {
    name: 'Не гарантия',
    value: 0,
  },
  garanty: {
    name: 'Гарантия',
    value: 0,
  },
  mayBeGaranty: {
    name: 'Возможно гарантия',
    value: 0,
  },
  isChargeable: {
    name: 'Платные',
    value: 0,
  },
  isImmediate: {
    name: 'Аварийные',
    value: 0,
  },
  isRetry: {
    name: 'Повторные',
    value: 0,
  },
  isInternal: {
    name: 'Внутренняя',
    value: 0,
  },
};
